import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Strong, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"uvedomleniya-o-zakazakh-v-magazine-v-telegram"} />
		<Helmet>
			<title>
				Уведомления о заказах с магазина в Телеграм
			</title>
			<meta name={"description"} content={"Получаем уведомления в Телеграм о заказах с интернет-магазина "} />
			<meta property={"og:title"} content={"Уведомления о заказах с магазина в Телеграм"} />
			<meta property={"og:description"} content={"Получаем уведомления в Телеграм о заказах с интернет-магазина"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Link
						href="https://t.me/uShopWebBot?start=web"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="12px 24px 12px 24px"
						background="--dark"
						border-radius="50px"
						transition="--opacityOut"
						hover-opacity=".8"
						target="_blank"
						md-padding="12px 20px 12px 20px"
					>
						Создать веб-бота
					</Link>
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1654764449734-bc2d2a2cece2?ixlib=rb-4.0.3&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=2000) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Уведомления о новых заказах в Телеграм
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Все уведомления о заказах попадают на Ваш почтовый ящик, но вы можете также подключить Telegram-бота и получать уведомления прямо в мессенджер!
			</Text>
			<Link
				href="https://t.me/uSportClothes"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				text-align="center"
			>
				Пример интернет-магазина в Телеграм
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Text
				id="shop"
				margin="0px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h3"
				color="--dark"
			>
				Создание бота уведомлений в Telegram
				<br />
				{"\n\n"}
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Сперва нужно открыть диалог с ботом @BotFather. Для этого можете перейти по ссылке{" "}
				<Link
					href="https://t.me/botfather"
					color="--primary"
					text-decoration-line="initial"
					target="_blank"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					https://t.me/botfather
				</Link>
				<br />
				<br />
				После перехода у вас откроется страница с диалогом. В окне напишите команду /newbot
				<br />
				<Strong
					color="--red"
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Важно! Вам нужно создать для уведомлений нового бота, использовать бот магазин повторно нельзя!
					<br />
				</Strong>
				<br />
				В ответ на команду, вас попросят придумать имя боту.
				<br />
				После того, как вы напишите желаемое имя, вас попросят ввести юзернэйм бота (по сути логин, по которому бота можно найти). Для юзернэйма обязательным параметром является уникальность логина и наличие приставки `bot` в конце.
				<br />
				<br />
				После того, как вы ввели логин бота, в ответ вам придет сообщение про успешное создание бота, и TOKEN.
				<br />
				<Strong
					overflow-wrap="normal"
					word-break="normal"
					white-space="normal"
					text-indent="0"
					text-overflow="clip"
					hyphens="manual"
					user-select="auto"
					pointer-events="auto"
				>
					Внимание! Не сообщайте полученный TOKEN сторонним людям. Зная TOKEN, можно получить доступ к управлению самим ботом.
				</Strong>
				<br />
				<br />
				Пример создания TG бота показан на скриншоте:{"\n\n"}
			</Text>
			<Image
				src="https://newmanuals.ucoz.net/_pu/6/s03036505.jpg"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				width="640px"
				md-width="100%"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Поздравляю! Только что вы создали своего бота
				<br />
				Для подключения мессенжера, вам необходимо со старой панели управления перейти на вкладку Настройки - Мессенджеры{"\n\n"}
			</Text>
			<Image
				src="https://newmanuals.ucoz.net/_pu/6/47542064.png"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				width="640px"
				md-width="100%"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				После перехода у вас откроется следующее окно:{"\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21:45:23.225Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot.png?v=2023-02-22T21%3A45%3A23.225Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Введите полученный TOKEN и username в соответствующие поля и нажмите подключить.
				<br />
				В случае успешного подключения, у вас отобразился надпись "Чат-бот username_bot подключен"{"\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21:45:36.485Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot2.png?v=2023-02-22T21%3A45%3A36.485Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Отлично, мы подключили бота. Теперь нужно подключить аккаунты, на которые будут отправляться уведомления. Для этого, на этой же странице, в блоке "Аккаунты администраторов сайта" нажмите на ссылку мессенджера
				<br />
				{"\n\n\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21:49:47.904Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot3.png?v=2023-02-22T21%3A49%3A47.904Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				У вас откроется окно с вашим ботом. Нажмите "Запустить".
				<br />
				{"\n\n"}
			</Text>
			<Image
				src="https://newmanuals.ucoz.net/_pu/6/s67689571.jpg"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				width="640px"
				md-width="100%"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Отлично, мы подключили бота. Теперь нужно подключить аккаунты, на которые будут отправляться уведомления. Для этого, на этой же странице, в блоке "Аккаунты администраторов сайта" нажмите на ссылку мессенджера
				<br />
				{"\n\n\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21:50:57.764Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot4.png?v=2023-02-22T21%3A50%3A57.764Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				После чего откройте диалог с вашим ботом и отправьте сообщение /start ключ. Пример:
				<br />
				{"\n\n"}
			</Text>
			<Image
				src="https://newmanuals.ucoz.net/_pu/6/34802830.png"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				width="640px"
				md-width="100%"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Откройте страницу с мессенджерами в панели управления и нажмите на значок обновления в блоке с аккаунтами. Если все сделано правильно, у вас появится иконка с именем подключенного администратора
				<br />
				{"\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21:52:59.533Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot5.png?v=2023-02-22T21%3A52%3A59.533Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--dark"
			>
				Добавляем @username клиента в уведомления
			</Text>
			<Text margin="12px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Если мы подключили все правильно, то теперь уведомления о новых заказах будут приходить в Телеграм, помимо этого, для более удобной коммуникации с пользователем, мы можем добавить в уведомления @username пользователя, пример:{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22:04:13.396Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/nottelegram.png?v=2023-02-22T22%3A04%3A13.396Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Для этого зайдите в модуль "Интернет-магазин" и выберите раздел "Настройка уведомлений"
				<br />
				{"\n\n"}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22:06:16.904Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegram-not5.png?v=2023-02-22T22%3A06%3A16.904Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Возле флажка "Telegram" нажмите на иконочку "Карандаша", после чего у вас откроется всплывающее окно.
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22:06:26.795Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot6.png?v=2023-02-22T22%3A06%3A26.795Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				В это окно(шаблон уведомлений), вам нужно добавить условный оператор: @$USERNAME_TG_SHOP$, в любое место, пример добавленного кода:
			</Text>
			<Text
				margin="8px 0px 16px 0px"
				font="normal 500 16px/175% --fontFamily-googleMontserrat"
				sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif"
				color="--grey"
				padding="20px 20px 20px 20px"
				border-radius="12px"
				background="--background"
			>
				&lt;b&gt;Оформлен новый заказ &lt;?if($USERNAME_TG_SHOP$)?&gt; от клиента: @$USERNAME_TG_SHOP$&lt;?endif?&gt;&lt;/b&gt;
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22:01:13.975Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/telegramnot7.png?v=2023-02-22T22%3A01%3A13.975Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="4px 0px 0px 0px" font="italic 500 16px/160% --fontFamily-googleMontserrat" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--grey">
				Пример добавленного кода
			</Text>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--dark"
			>
				Добавляем информацию с полей заказа (Адрес, телефон, имя и пр.){" "}
			</Text>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Заходим в раздел "Управление полями заказа":{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16:26:46.350Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/polyazakaza.png?v=2024-04-01T16%3A26%3A46.350Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Выбираем нужно поле, которое мы хотим отобразить в уведомлениях и копируем его условный оператор, в нашем случае это $ORDER_FIELD_2$:
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16:28:53.953Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/operatororder.png?v=2024-04-01T16%3A28%3A53.953Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Скопированный оператор вставляем в наш шаблон уведомлений, пример:{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11:39:20.360Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/adressdostavkil.png?v=2024-04-03T11%3A39%3A20.360Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Готово! Так мы можем отобразить любое поле
			</Text>
			<Text
				id="shop"
				margin="30px 0px 14px 0px"
				font="--headline2"
				sm-font="normal 800 20px/130% &quot;Montserrat&quot;, sans-serif"
				as="h2"
				color="--dark"
			>
				Уведомления в чате
			</Text>
			<Text margin="10px 0px 16px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Если вы хотите, чтобы уведомление приходило в чат сразу нескольким менеджерам\курьерам которые состоят в этой группе, то вам нужно:
				<br />
				<br />
				1. Создать группу
				<br />
				2. Добавить бот-уведомлений в эту группу с правами администратора (чтобы у него был доступ к сообщениям как на скриншоте)
				<br />
				3. Прописаться команду /start и ключ как на скриншоте:{" "}
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16:46:49.674Z"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/groupnotlify.png?v=2024-05-26T16%3A46%3A49.674Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Бот-Магазин в Телеграм под ключ за 9800 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
		</RawHtml>
	</Theme>;
});